<div class="row">
  <label [for]="label" class="col-6 d-flex align-items-center required">{{ label }}</label>
  <div class="col d-flex align-items-center">
    <mat-form-field>
      <input
        trim="blur"
        matInput
        [formControl]="formControl"
        [dir]="languageType === 'arabic' ? 'rtl' : 'ltr'"
        type="text"
        [id]="label"
        [attr.data-testid]="'tray-title-input-' + languageType"
        autocomplete="off"
        [disabled]="isDisabled"
      />
    </mat-form-field>
  </div>
</div>
